var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jv16v0zqra)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.667 14.667H3a1.29 1.29 0 0 1-1.333-1.333V6.667A1.29 1.29 0 0 1 3 5.334h2.667V2.667A1.29 1.29 0 0 1 7 1.334h6.666A1.29 1.29 0 0 1 15 2.667v6.667a1.29 1.29 0 0 1-1.334 1.333H11v2.667a1.29 1.29 0 0 1-1.333 1.333zM3 6.667v6.667h6.667v-2.667H7a1.29 1.29 0 0 1-1.333-1.333V6.667H3zm4-4v6.667h6.666V2.667H7z",
    fill: "#444950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jv16v0zqra"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.333)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.6bde11f38591d7d8d67f9ad058e608ca.svg";
export { ForwardRef as ReactComponent };